import React, { useMemo, useState } from "react";
import classNames from "classnames";
import BorrowRepay from "./BorrowRepay";
import Recollateralize from "./Recollateralize";
import { trade } from "../../placeholder";
import { useSelector } from "react-redux";
import coinLogos from "../../assets/images/currency-icons/coinLogos.js";
import { BigNumber, ethers } from "ethers";
import { Web3Context } from "../../contexts/Web3Context";

export default function () {
  const asset = useSelector((state) => state.modal.data.asset);

  const buttons = useMemo(() => {
    return ["Borrow", "Repay", "Loan Status"];
  }, []);

  const [page, setPage] = useState(buttons[0]);
  const formData = useState({
    value: "",
    asset: "",
    email: "",
    type: null,
    callateral: trade[0],
  });

  const pageHandler = (page) => {
    formData[1]({
      value: "",
      asset: "",
      email: "",
      type: null,
      callateral: trade[0],
    });

    setPage(page);
  };

  return (
    <div className="modal modal_trade modal_w650">
      <header className="modal-header modal-header_big">
        <div className="modal-header__currency">
          <img src={coinLogos[asset.index]} alt="icon" />
          <span>{asset.name}</span>
        </div>
        <div className="modal-header__controls">
          {buttons.map((name) => (
            <button
              className={classNames("custom-gradient-btn", {
                active: page === name,
                Recollateralize: page === "custom-gradient-btn_recol",
              })}
              onClick={() => pageHandler(name)}
            >
              <span>{name}</span>
            </button>
          ))}
        </div>
      </header>
      {(page === buttons[0] || page === buttons[1]) && (
        <BorrowRepay page={page} data={formData} list={trade} />
      )}
      {page === buttons[2] && <Recollateralize data={formData} asset={asset} />}
    </div>
  );
}
